<template>
  <div>
    <div class="page" v-if="!loading">
      <form ref="form" autocomplete="off" @submit.prevent="add">
        <div class="page__header">
          <div class="page__header-title">
            {{ isEdit ? "Update Tenant" : "Add Tenant" }}
            <div class="page__header-subtitle">
              {{ isEdit ? "Update Tenant Details" : "Onboard a new tenant" }}
            </div>
          </div>
          <div class="page__header-tools"></div>
        </div>
        <hr />
        <div class="page__body">
          <div class="row">
            <div class="col">
              <b-form-group
                label="Tenant Name"
                label-size="sm"
                label-class="form__label label-required"
              >
                <b-form-input
                  :value="tenant.name"
                  required
                  size="sm"
                  trim
                  maxlength="90"
                  @change="setName"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Tenant Organization"
                label-size="sm"
                label-class="form__label label-required"
              >
                <b-form-input
                  :value="tenant.organization"
                  required
                  size="sm"
                  trim
                  maxlength="90"
                  @change="setOrganization"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group
                label="Tenant Domain"
                label-size="sm"
                label-class="form__label label-required"
              >
                <b-form-input
                  :value="tenant.domain"
                  required
                  size="sm"
                  trim
                  maxlength="90"
                  @change="setDomain"
                ></b-form-input>
              </b-form-group>
              <div class="row justify-content-end pr-5">
                <button
                  @click="resetKeys"
                  class="btn btn-success btn-sm mt-4"
                  type="button"
                  v-if="isEdit"
                >
                  Reset API keys
                </button>
              </div>
            </div>
          </div>
          <hr v-if="!isEdit" />
          <div class="page__header" v-if="!isEdit">
            <div class="page__header-title">
              Administrators
              <div class="page__header-subtitle">
                Add administrator accounts
              </div>
            </div>
            <div class="page__header-tools">
              <div class="row justify-content-end pr-5">
                <button
                  @click="openAdminModal"
                  class="btn btn-success btn-sm"
                  type="button"
                >
                  <i class="icon-user-plus"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="" v-if="!isEdit">
            <ef-table
              :items="admins"
              :fields="fields"
              :busy="loading"
              :actions="['delete']"
              :confirm-message="'Remove this admin?'"
              @delete="deleteAdmin"
            >
            </ef-table>
          </div>
        </div>
        <b-modal
          modal-class="flyout__modal"
          content-class="flyout__modal-contents"
          scrollable
          hide-footer
          hide-header
          no-fade
          no-close-on-backdrop
          ref="modal-add-admin"
          id="modal-add-admin"
          v-if="!isEdit"
        >
          <add-admin
            @addUser="addAdmin"
            @cancel="$bvModal.hide('modal-add-admin')"
          ></add-admin>
        </b-modal>
        <hr />
        <b-row>
          <b-col cols="9"> </b-col>
          <b-col cols="3">
            <b-button
              class="form__button"
              size="sm"
              variant="light"
              @click="cancel()"
              >Cancel</b-button
            >
            <b-button
              class="form__button"
              size="sm"
              variant="success"
              type="submit"
              >{{ isEdit ? "Save" : "Add Tenant" }}</b-button
            >
          </b-col>
        </b-row>
      </form>
    </div>
    <loader v-else />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import toast from "./../toaster";
import EfTable from "./../components/EfTable";
const {
  mapState,
  mapActions,
  mapGetters,
  mapMutations,
} = createNamespacedHelpers("admin/tenants");
import AddAdmin from "./../components/AddAdmin";
export default {
  props: ["isEdit", "tenantId"],
  async mounted() {
    if (this.isEdit && !this.tenantId) {
      this.$router.push("/admin/super-admin/tenants");
    }
    if (this.tenantId) {
      await this.loadTenant(this.tenantId);
    }
  },
  components: {
    AddAdmin,
    EfTable,
  },
  methods: {
    ...mapActions([
      "insertAdmin",
      "addTenant",
      "deleteAdmin",
      "updateTenant",
      "loadTenant",
      "reset",
      "resetApiKeys",
    ]),
    ...mapMutations(["setOrganization", "setName", "setDomain", "stopLoading"]),
    openAdminModal() {
      this.$refs["modal-add-admin"].show();
    },
    addAdmin(data) {
      this.insertAdmin(data)
        .then((result) => {
          this.$refs["modal-add-admin"].hide();
        })
        .catch((err) => {
          this.stopLoading();
          toast.showToasts(this, err.message, "danger");
        });
    },
    async add() {
      if (!this.isEdit) {
        this.addTenant()
          .then((result) => {
            toast.showToasts(this, "Tenant added successfully.", "success");
            this.$router.push("/admin/super-admin/tenants");
          })
          .catch((err) => {
            this.stopLoading();
            toast.showToasts(this, err.message, "danger");
          });
      } else {
        this.updateTenant(this.tenantId)
          .then((result) => {
            toast.showToasts(this, "Tenant updated successfully.", "success");
            this.$router.push("/admin/super-admin/tenants");
          })
          .catch((err) => {
            this.stopLoading();
            toast.showToasts(this, err.message, "danger");
          });
      }
    },
    cancel() {
      this.$router.back();
    },
    resetKeys() {
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to reset API keys for this tenant? ?",
          {
            modalClass: "confirm__modal",
            contentClass: "confirm__modal-contents",
            title: "Please Confirm",
            size: "sm",
            buttonSize: "sm",
            cancelVariant: "light",
            okTitle: "YES",
            cancelTitle: "NO",
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.resetApiKeys(this.tenantId)
              .then((result) => {
                toast.showToasts(
                  this,
                  "API keys reset successfully.",
                  "success"
                );
              })
              .catch((err) => {
                this.stopLoading();
                toast.showToasts(
                  this,
                  "There was an error. Please try again.",
                  "danger"
                );
              });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
  },
  computed: {
    ...mapState(["tenant", "loading"]),
    ...mapGetters({
      admins: "users/getAll",
    }),
  },
  data() {
    return {
      fields: [
        { key: "firstName" },
        { key: "lastName" },
        { key: "email" },
        { key: "Actions" },
      ],
    };
  },
  destroyed() {
    this.reset();
  },
};
</script>

<style lang="scss">
</style>